<template>
  <div class="products" id="products">
    <div class="products-content">
      <a href="http://www.hihonor.com/se/products/mobile-phones/honor9/index.html" target="_blank" class="product product-blue"></a>
      <a href="http://www.hihonor.com/se/products/mobile-phones/honor9/index.html" target="_blank" class="product product-black"></a>
      <a href="http://www.hihonor.com/se/products/mobile-phones/honor9/index.html" target="_blank" class="product product-grey"></a>
      <div class="clear: both;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'products',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .products {
    border-bottom: 1px solid #cccccc;
  }
  .products-content {
    text-align: center;
    width: 100%;
    max-width: 1600px;
    height: 38vh;
    margin: auto;
    margin-top: 50px;
  }
  .product {
    float: left;
    height: 38vh;
    width: 30%;
    background-position: bottom;
    background-size: contain;
    background-blend-mode: none;
    background-repeat: no-repeat;
    -webkit-transition: all 300ms;
    transition: all 300ms;
  }
  .product:hover {
    opacity: 0.8;
    -webkit-transition: all 300ms;
    transition: all 300ms;
  }
  .product-blue {
    float: left;
    background-position: right bottom;
    background-image: url('./../assets/img/product_blue-min.jpg');
  }
  .product-black {
    width: 30%;
    margin-right: 5%;
    margin-left: 5%;
    display: inline-block;
    background-position: center bottom;
    background-image: url('./../assets/img/product_black-min.jpg');
  }
  .product-grey {
    float: right;
    background-position: left bottom;
    background-image: url('./../assets/img/product_grey-min.jpg');
  }
  @media only screen and (max-width: 900px) {
    .products-content {
      text-align: center;
      width: 100%;
      max-width: 1600px;
      height: 38vh;
      margin: auto;
      margin-top: 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// Products.vue?0aefffb1